import { Styles } from 'react-jss';

const styles: Styles = {};

export default styles;
